import { axiosApi } from "../../../api/dbAxios";

export const fetchTeamList = async () => {
  try {
    const response = await axiosApi.get(`/teams/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching team list:", error);
    return [];
  }
};
